export default __webpack_public_path__ + "static/media/bmi.8e419d60.svg";